"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileFieldLogic = void 0;
var file_fieldtype_1 = require("./file.fieldtype");
Object.defineProperty(exports, "FileFieldLogic", { enumerable: true, get: function () { return file_fieldtype_1.FileFieldLogic; } });
